import { data } from "./generated/data.js";
import { z } from "@repo/utils";
import type { CountryCode2, CountryCode3 } from "./types.js";

const codes2 = data.map(x => x["alpha-2"]) as [CountryCode2, ...CountryCode2[]];
export const CountryCode2Schema = z.enum(codes2);

const codes3 = data.map(x => x["alpha-3"]) as [CountryCode3, ...CountryCode3[]];
export const CountryCode3Schema = z.enum(codes3);
